module.exports = __webpack_public_path__ + "assets/icon-groups-component.891e70d3.svg";